import { Text } from '@innovationdepartment/proxima-ui';
import { BRAND_CATEGORY_LABELS } from 'constants/brandCategories';
import type { BrandSectionProps } from 'types/brandOverview';
import Tag from 'ui/Tag';
import PageLayoutSectionView from '../../PageSectionLayout.View';

const BrandProfileView = ({ category }: BrandSectionProps) => {
  let content = (
    <Text variant="body2" color="neutral80">
      -
    </Text>
  );

  if (category) {
    content = <Tag label={BRAND_CATEGORY_LABELS[category]} variant="tag1Medium" />;
  }

  return (
    <PageLayoutSectionView
      sections={[
        {
          label: 'Primary category',
          content
        }
      ]}
    />
  );
};

export default BrandProfileView;
